// removed by extract-text-webpack-plugin
module.exports = {"navbarLinks":"navbarLinks--1LeJb"};